import { formatCurrency } from "src/shared/hooks/formatCurrency"
import Table from "../../PDFTable/Table/Table"
import Row from "../../PDFTable/Row/Row"
import Cell from "../../PDFTable/Cell/Cell"
import { useEffect, useState } from "react"
import { minus } from "src/shared/helpers/calculator"
import { GetCorteQuery } from "src/gql/schema"
import { ManejoEfectivo, ResultadoCorte, TotalCorte } from "../../../sections/interfaces/cortes-pdf"

const Totales = ({ resultado_corte, corte, totales, anticipos_validos_total, anticipos_validos_resultado,  manejo_efectivo, gastos }: {
    resultado_corte: ResultadoCorte,
    corte?: GetCorteQuery,
    totales: TotalCorte,
    anticipos_validos_resultado: number,
    anticipos_validos_total: string,
    manejo_efectivo: ManejoEfectivo
    gastos: number
}) => {
    const [diferenciaEfectivo, setDiferenciaEfectivo] = useState<number>(0)

    useEffect(() => {
        setDiferenciaEfectivo(
            corte?.corte?.fecha_cierre_corte
                ? minus(manejo_efectivo?.efectivo_caja || 0, corte?.corte?.efectivo_ingresado)
                : 0
        )
    }, [corte])

    return (
        <Table style={{ marginTop: 10, border: "none", width: "100%" }}>
            <Row fixed
                style={{
                    borderBottom: "0.5px solid #4A5468",
                }}
            >
                <Cell textStyle={{ fontWeight: 700, fontSize: 8 }}>Resultado del corte</Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Efectivo
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.efectivo || 0))}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Visa o mastercard
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.visa_o_mastercard || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Depósitos/Trans
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.deposito_transferencia || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    AMEX
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.amex || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Cortesías
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.cortesia || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Consumo interno
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.consumo_interno || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Love Points
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.love_points || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Anticipos válidos
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(anticipos_validos_resultado || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Pago de propinas
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte.pago_propinas || 0) || 0)}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Otros gastos
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    {formatCurrency(Number(resultado_corte?.gastos || 0) || 0)}
                </Cell>
            </Row>
            <Row
                style={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    borderTop: "0.5px solid #4A5468",
                    borderBottom: "0.5px solid #4A5468",
                }}
            >
                <Cell textStyle={{ fontWeight: 700, width: "28vw", textAlign: "left", fontSize: 8, color: "#000000" }}>
                    Total de ingresos
                </Cell>
                <Cell textStyle={{ fontWeight: 700, width: "18vw", textAlign: "right", fontSize: 8, color: "#000000" }}>
                    {formatCurrency(totales.subtotal)}
                </Cell>
            </Row>
            {corte?.corte?.fecha_cierre_corte && diferenciaEfectivo !== 0 && (
                <Row>
                    <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                        {diferenciaEfectivo > 0 ? `Sobrante` : `Faltante`}
                    </Cell>
                    <Cell
                        width="18vw"
                        textStyle={{
                            color: "#5E6470",
                            textAlign: "right",
                            fontSize: 8,
                        }}
                    >
                        {diferenciaEfectivo > 0
                            ? formatCurrency(diferenciaEfectivo)
                            : `-${formatCurrency(Math.abs(diferenciaEfectivo))}`}
                    </Cell>
                </Row>
            )}
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Anticipos válidos
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    -{formatCurrency(Number(anticipos_validos_total))}
                </Cell>
            </Row>
            <Row>
                <Cell width="28vw" textStyle={{ fontSize: 7 }}>
                    Gastos
                </Cell>
                <Cell
                    width="18vw"
                    textStyle={{
                        color: "#5E6470",
                        textAlign: "right",
                        fontSize: 7,
                    }}
                >
                    -{formatCurrency(gastos)}
                </Cell>
            </Row>
            <Row
                style={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    borderTop: "0.5px solid #4A5468",
                }}
            >
                <Cell textStyle={{ width: "28vw", textAlign: "left", fontSize: 8, color: "#6941C6" }}>
                    Total del turno
                </Cell>
                <Cell textStyle={{ width: "18vw", textAlign: "right", fontSize: 8, color: "#6941C6" }}>{formatCurrency(totales.total || 0)}</Cell>
            </Row>
        </Table>
    )
}

export default Totales
